new Swiper('.testimonial-slider', {
      pagination: {
        el: '.swiper-paginations',
        clickable: true,
      },

     breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        540: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
     },
});